import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
// TODO: rename to SnackbarService
export class ErrorPanelService {
  private showErrorPanelSubject = new BehaviorSubject<boolean>(false);
  private errorMessageSubject = new BehaviorSubject<string>('');

  showErrorPanel$ = this.showErrorPanelSubject.asObservable();
  errorMessage$ = this.errorMessageSubject.asObservable();

  errorMessage: string = '';

  private isErrorSnackbarVisible = false;
  private currentErrorSnackbarRef: MatSnackBarRef<any> | null = null;
  private lastErrorMessage: string = '';

  private readonly ERROR_SNACKBAR_CONFIG = {
    horizontalPosition: 'center' as const,
    verticalPosition: 'bottom' as const,
    panelClass: ['error-snackbar'],
  };

  private readonly INFO_SNACKBAR_CONFIG = {
    horizontalPosition: 'center' as const,
    verticalPosition: 'bottom' as const,
    panelClass: ['info-snackbar'],
    duration: 3000,
  };

  constructor(private snackBar: MatSnackBar) {}

  showErrorPanel(errorMessage: string) {
    this.errorMessageSubject.next(errorMessage);
    this.showErrorPanelSubject.next(true);
  }

  showErrorSnackBar(errorMessage: string) {
    if (this.errorMessage === '') {
      // Primo messaggio non ha il prefisso
      this.errorMessage = errorMessage;
    } else {
      if (!this.errorMessage.startsWith('- ')) {
        this.errorMessage = '- ' + this.errorMessage;
      }
      this.errorMessage += '\n - ' + errorMessage;
    }

    this.isErrorSnackbarVisible = true;
    this.lastErrorMessage = this.errorMessage;

    this.showErrorSnackbarInternal();
  }

  private showErrorSnackbarInternal() {
    this.currentErrorSnackbarRef = this.snackBar.open(
      this.lastErrorMessage,
      'Chiudi',
      this.ERROR_SNACKBAR_CONFIG
    );

    this.currentErrorSnackbarRef.onAction().subscribe(() => {
      this.currentErrorSnackbarRef = null;
      this.errorMessage = '';
      this.lastErrorMessage = '';
      this.isErrorSnackbarVisible = false;
    });
  }

  showInfoSnackBar(infoMessage: string) {
    // Store the error snackbar state
    const wasErrorVisible = this.isErrorSnackbarVisible;

    // Show info snackbar at the top
    this.snackBar.open(infoMessage, 'Chiudi', {
      ...this.INFO_SNACKBAR_CONFIG,
    });

    // If error was visible, reopen it after a brief delay
    if (wasErrorVisible) {
      setTimeout(() => {
        this.showErrorSnackbarInternal();
      }, 3000);
    }
  }

  closeErrorPanel() {
    this.showErrorPanelSubject.next(false);
    this.errorMessageSubject.next('');
  }
}
